namespace SorAraBul.Administration {
    export interface UserCreditPaymentOrderForm {
        PaymentCode: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        UserDisplayName: Serenity.StringEditor;
        UserEmail: Serenity.StringEditor;
        CompanyId: Serenity.LookupEditor;
        CompanyName: Serenity.StringEditor;
        PurchasePackageName: Serenity.StringEditor;
        CreditCount: Serenity.IntegerEditor;
        Amount: Serenity.DecimalEditor;
        Status: Serenity.StringEditor;
        InsertDate: Serenity.DateEditor;
        PaidDate: Serenity.DateEditor;
        RawCallback: Serenity.TextAreaEditor;
    }

    export class UserCreditPaymentOrderForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.UserCreditPaymentOrder';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserCreditPaymentOrderForm.init)  {
                UserCreditPaymentOrderForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;
                var w5 = s.TextAreaEditor;

                Q.initFormType(UserCreditPaymentOrderForm, [
                    'PaymentCode', w0,
                    'UserId', w1,
                    'UserDisplayName', w0,
                    'UserEmail', w0,
                    'CompanyId', w1,
                    'CompanyName', w0,
                    'PurchasePackageName', w0,
                    'CreditCount', w2,
                    'Amount', w3,
                    'Status', w0,
                    'InsertDate', w4,
                    'PaidDate', w4,
                    'RawCallback', w5
                ]);
            }
        }
    }
}
